export const activity = {
  activityWebEmptyStateTitle: 'Nenhuma atividade ainda',
  activityWebEmptyStateText: 'Aqui estará o seu feed de notificações',
  activitySeeAll: 'Ver tudo',
  in: 'em'
}
